import PropTypes from "prop-types";

import { cn } from "@helpers/general";
import { ComponentType } from "@constants/ComponentType";
import useDeviceDetect from "@hooks/useDeviceDetect";

function ProgressText({
  content,
  firstTierReached,
  lastTierReached,
  freeGiftMinAmount,
  freeGiftDiscount,
  componentType,
}) {
  const { isMobile } = useDeviceDetect();

  const addMargins =
    componentType !== ComponentType.ANNOUNCEMENT_BAR ||
    (componentType === ComponentType.ANNOUNCEMENT_BAR && isMobile);

  if (!lastTierReached && freeGiftMinAmount && freeGiftDiscount > 0) {
    return (
      <p className={cn("typo-micro font-bold", addMargins && "mb-[10px]")}>
        You&apos;ve Unlocked Your Free Gift
      </p>
    );
  }
  if (firstTierReached && !lastTierReached && freeGiftMinAmount) {
    return (
      <p className={cn("typo-micro font-bold", addMargins && "mb-[10px]")}>
        Unlock a Free Gift with Your Order
      </p>
    );
  }

  return content;
}

export default ProgressText;

ProgressText.propTypes = {
  content: PropTypes.node,
  firstTierReached: PropTypes.bool,
  lastTierReached: PropTypes.bool,
  freeGiftMinAmount: PropTypes.number,
  freeGiftDiscount: PropTypes.number,
  componentType: PropTypes.string,
};
